import React, { useContext, useRef, useState } from "react";
import {
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import ChargesOneTime from "./ChargesOneTime";
import ChargesRecurring from "./ChargesRecurring";
import { chargesTabChange } from "./constants/displayInfinite";
import { CreateOfferContext } from "./context";
import { isEmptyorInvalidFieldForGrantsAndCharges } from "./constants/checkEmptyFields";
import { recurringFrequencyOptions } from "./constants/initialValues";

const Charges = () => {
  const {
    isSubscribed,
    values,
    touched,
    setTouched,
    overrideCharge,
    overrideChargeRecurring,
    stateCharges,
    chargesActiveTab,
    setChargesActiveTab,
    serviceBarringState,
  } = useContext(CreateOfferContext);
  const pushOneTimeRef = useRef(null);
  const pushRecurringRef = useRef(null);
  return (
    <Row className="mb-4">
      <Col lg={12}>
        {values?.recurringCharges?.length === 0 ? (
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ marginTop: "120px" }}
          >
            {isSubscribed ? (
              <div className="text-center mb-2">
                There are no Charges available for this offer.
              </div>
            ) : (
              <div className="text-center mb-2">
                There are no Charges available for this offer, Add a Charge to
                proceed.
              </div>
            )}

            {!isSubscribed && (
              <Button
                color="secondary"
                className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 text-nowrap mt-0"
                onClick={() => {
                  const lastIndex = values.recurringCharges.length - 1;
                  if (
                    lastIndex === -1 ||
                    !isEmptyorInvalidFieldForGrantsAndCharges(
                      lastIndex,
                      values.recurringCharges
                    )
                  ) {
                    pushRecurringRef.current &&
                      pushRecurringRef.current({
                        recurringFrequency: recurringFrequencyOptions[0],
                        recurringFrequencyUnit: 1,
                        cycleAlignment: {
                          value: 1,
                          label: "Billing Cycle",
                        },
                        resourceType: "",
                        resourceValue: "0",
                        infinite: "",
                        ceiling: "",
                        floor: "",
                        type: serviceBarringState ? "2" : "1",
                        override: overrideChargeRecurring,
                        prorate: stateCharges,
                      });
                    setTouched({
                      ...touched,
                      recurringCharges: {
                        ...touched.recurringCharges,
                        [lastIndex]: {
                          resourceType: false,
                        },
                      },
                    });
                  }
                }}
              >
                {" "}
                <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i>{" "}
                <span className="px-0 ps-2 ms-2 me-1">Add Charge </span>
              </Button>
            )}
          </div>
        ) : null}
        <ChargesRecurring pushRef={pushRecurringRef} />
      </Col>
    </Row>
  );
};

export default Charges;
